import { useNavigate } from 'react-router-dom'
import { useSelector } from "react-redux";

const Subcategorynew = ({value,setwdith,index = 0}) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
const nvg = useNavigate();

const transfer = (id,value)=>{
  nvg(`/category/${id}/${value}/${btoa('none')}`);
}

const transfer2 = (value,title,maincategory) =>{
nvg(`/category/${value}/${maincategory} > ${title}/${btoa('none')}`);
}


const transfer3 = (value, subcategory,main,subsubcategory) => {
  nvg(`/category/${value}/${main} > ${subcategory} > ${subsubcategory}/${btoa('none')}`);
};
const getColumnChunks = (children) => {
  const length = children.length;

  if (length > 3) {
    const chunkSize = Math.ceil(length / 3);
    const result = [];
    for (let i = 0; i < length; i += chunkSize) {
      result.push(children.slice(i, i + chunkSize));
    }
    return result;
  } else {
    return children.map((child) => [child]);
  }
};

const columns = getColumnChunks(value.child);
// console.log(columns,"columns");

// Dynamically calculate width: assume ~250px per column
const containerWidth = `${columns.length * 200}px`;



  return (
    <li className={setwdith == 0 ? "" : "mega"}>
        {setwdith == 0 ? <button
   className="btn dark-menu-item desgin1"
   style={{padding:"6px 18px 0px 18px"}}
   onClick={()=>{transfer(value.category_id,value.category_name)}}
 >

   &nbsp;{" "}
   <span className="largefont"> {value.category_name} </span>


 </button> : <button
                             type="button"
                            className="btn dark-menu-item desgin1 ulappear category-v2-updation-hover-style"
                            style={{padding:"10px 18px 0px 18px" ,borderRadius: "0px" ,}}

                          >

                            {/* &nbsp;{" "} */}
                            <span className="largefontv2 desgin1"> {value.category_name}</span>
                          </button>}

                          { setwdith == 0 ? "" : 
                          
                          <ul className={setwdith == 0 ? "mega-menu full-mega-menu resultappear newwith" : value.child.length < 3 ? `mega-menu full-mega-menu resultappear ${index == 0 || index == 1 ? 'newwith5again' : 'newwith3again'}` : "mega-menu full-mega-menu resultappear newwith2"} style={{border : "0px",padding : "0px",width : "fit-content !important"}}  >
                            <div
  className=" p-0"
  style={{
    maxWidth: containerWidth,
  }}
>
  <div  className='raw' style={{ padding: '0px 0px 0px 0px' ,display : "flex"}}>
    {columns.map((col, colIndex) => (
      <div
        className={`col-${12 / columns.length}`}
        key={colIndex}
        style={{
          backgroundColor: colIndex % 2 === 0 ? '#ffffff' : '#f5fbf7',
          // paddingTop: '20px',
          // paddingBottom: '20px',
          padding:'17px 14px',
          width:'fit-content'

          // opacity : colIndex % 2 === 0 ? '100' : '0.2',
        }}
      >
        {col.map((item, index) => (
          <div className="link-section" key={index}>
            <div className="menu-title">
              <h5
                onClick={() => transfer2(item.id, item.name, value.category_name)}
                style={{
                  cursor: 'pointer',
                  fontWeight: 1000,
                  textWrap: 'nowrap',
                  textDecoration: 'none',
                  margin : "6px",
                  transition: 'color 0.3s ease, textDecoration 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = `#${textColor}`;
                  e.target.style.textDecoration = 'underline';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '';
                  e.target.style.textDecoration = 'none';
                }}
              >
                {item.name}
              </h5>

              <ul style={{ marginBottom: '10px'}}>
                {item.children.map((item3, i) => (
                  <li
                    key={i}
                    style={{
                      color: '#504f4f',
                      fontSize: '11px',
                      marginBottom: '2px',
                      margin : "6px",

                    }}
                    onClick={() =>
                      transfer3(item3.id, item.name, value.category_name, item3.name)
                    }
                  >
                    <span className="changecolorhover">{item3.name}</span>
                  </li>
                ))}
              </ul>
            </div>
            {item.children?.length == 1 && (
                <div
                  style={{
                    height: '1.2px',
                    backgroundColor: '#0CB744',
                    marginBottom: '6px',
                    width : "70px",
                    margin : "6px",
                    position:'relative',
                    top:'1px',
                    paddingTop:"1px"

                  }}
                />
              )}
            {item.children?.length > 1 && (
                <div
                  style={{
                    height: '0.9px',
                    backgroundColor: '#0CB744',
                    marginBottom: '6px',
                    width : "70px",
                    margin : "6px",
                    position:'relative',
                    top:'1px',
                    paddingTop:"0px"

                  }}
                />
              )}
          </div>
        ))}
      </div>
    ))}
  </div>
</div>

                          </ul> }
 
</li>
  )
}

export default Subcategorynew